<template>
  <div>
    <vx-card>
      <ag-grid-vue
        style="width: 100%; height: 450px"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :rowData="rowData"
        :localeText="localeText"
        :pagination="true"
        @grid-ready="onGridReady"
        @first-data-rendered="onFirstDataRendered"
      >
      </ag-grid-vue>
    </vx-card>
  </div>
</template>
<script>
import Store from "../../store/store";
import state from "../../store/state";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import BABSDetayButon from "../components/crm-components/finans-components/BABSDetayButon.vue";
import babsCellRenderer from "./CellRenderers/babsCellRenderer.vue"
export default {
  data() {
    return {
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      columnDefs: null,
      rowData: null,
      localeText: null,
    };
  },
  components: {
    BABSDetayButon,
    AgGridVue,
    babsCellRenderer
  },
  methods: {
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      //  this.rpAcikFaturalarDetay();
    },
    getBabsList() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
      };
      soap.createClient(url, function (err, client) {
        client.INT_BABSLIST(args, function (err, result) {
          if (result.INT_BABSLISTResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          try {
            vm.veriler = JSON.parse(result.INT_BABSLISTResult);
            if (vm.veriler.response == "Ok") {
              var list = JSON.parse(vm.veriler.jsonData);
              vm.rowData = list;
            } else {
            }
          } catch (error) {}
        });
      });
    },
  },
  created() {
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
    this.getBabsList();
  },
  beforeMount() {
    this.columnDefs = [
      {
        width: 100,
        field: "",
        cellRendererFramework: "BABSDetayButon",
      },
      {
        headerName: "Yıl",
        field: "YIL",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Ay",
        field: "AY",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Gönderim Durumu",
        field: "GONDERIM",
        sortable: true,
        filter: "agDateColumnFilter",
        cellRenderer: 'babsCellRenderer',
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
    ];
  },
};
</script>